import React from 'react';
import { NavLink } from 'react-router-dom';
import './IntegrationHubTabs.css';

export default function IntegrationHubTabs() {
  return (
    <nav className="integration-hub-tabs" aria-label="Areas da central de integracoes">
      <NavLink to="/dispositivos" className={({ isActive }) => isActive ? 'active' : ''}>
        <i className="fas fa-print" aria-hidden="true"></i>
        <span>Impressoras e leitores</span>
      </NavLink>
    </nav>
  );
}
